export const getSweeprSupportBaseUrl = () => process.env.SWEEPR_SUPPORT_BASE_URL;

export const getSweeprWidgetUrls = () => {
    const supportBaseUrl = getSweeprSupportBaseUrl();

    return {
        widgetApplicationUrl: supportBaseUrl,
        widgetCssUrl: `${supportBaseUrl}/assets/widget/widget.css`,
        widgetJsUrl: `${supportBaseUrl}/assets/widget/widget.js`,
    };
};
